import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiConfig } from '../../../shared/services/api/config.api';
import { HttpClient } from '@angular/common/http';
import { throwError as observableThrowError } from 'rxjs';

@Injectable()
export class SendForgotPasswordService {
  constructor(public httpClient: HttpClient) {
  }

  getUser(empId, certNo, status, pNum, pSize) {
    return this.httpClient.get(ApiConfig.baseURL + 'api/admin/sendforgotpassword/page?employeeId=' + empId + '&certNo=' + certNo + '&status=' + status + '&page=' + pNum + '&size=' + pSize);
  }

  sendForgotPassword(userId) {
    return this.httpClient.post(ApiConfig.baseURL + 'api/admin/sendforgotpassword/' + userId, ApiConfig.requestOptionsHeader).pipe(
      catchError((error: any) => observableThrowError(error.json().error || 'Server error')));
  }
}
